import { api } from '@/lib/api';
import { build_params, download_export } from '@/lib/list-query';
import type { SortState } from '@/hooks/use-url-state';
import type {
  CommerceCounts,
  CommerceOrder,
  CommerceOrderListFilters,
  CommerceOrderListResponse,
} from './types';

/**
 * The list, with whatever filters and sort are set.
 *
 * Through `build_params` rather than a hand-written if-chain: the old version
 * enumerated eight filters by hand, so a filter added to the type but forgotten
 * here would look alive on screen while sending nothing.
 */
export async function fetch_commerce_order_list(
  filters: CommerceOrderListFilters,
  sort?: SortState,
): Promise<CommerceOrderListResponse> {
  const res = await api.get<CommerceOrderListResponse>('/admin/commerce/orders', {
    params: build_params(filters as Record<string, never>, sort),
  });
  return res.data;
}

export async function fetch_commerce_counts(): Promise<CommerceCounts> {
  const res = await api.get<CommerceCounts>('/admin/commerce/orders/counts');
  return res.data;
}

export async function export_commerce_orders(
  filters: CommerceOrderListFilters,
  sort?: SortState,
): Promise<void> {
  await download_export(
    '/admin/commerce/orders/export',
    build_params(filters as Record<string, never>, sort),
    'shop-orders.csv',
  );
}

export async function fetch_commerce_order_detail(id: string): Promise<CommerceOrder> {
  const res = await api.get<CommerceOrder>(`/admin/commerce/orders/${id}`);
  return res.data;
}
